var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconLongRead = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 15,
  viewBox: "0 0 21 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.4435 10.5733H18.129V9.26184H11.4435V10.5733ZM11.4435 8.40153H18.129V7.04886H11.4435V8.40153ZM11.4435 6.18855H18.129V4.83588H11.4435V6.18855ZM10.5 13.2382H19.0725V1.76259H10.5V13.2382ZM20.4255 0.532824C20.8088 0.888789 21 1.29871 21 1.76259V13.2374C21 13.702 20.8088 14.112 20.4255 14.4672C20.043 14.8224 19.5915 15 19.0725 15H1.9275C1.4085 15 0.957 14.8224 0.5745 14.4672C0.19125 14.112 0 13.702 0 13.2374V1.76259C0 1.29871 0.19125 0.888789 0.5745 0.532824C0.957 0.177608 1.4085 0 1.9275 0H19.0725C19.5915 0 20.043 0.177608 20.4255 0.532824Z",
  fill: "#999999"
}))));
export default SvgIconLongRead;